export const USER_TYPE = {
  FLEET: "Fleet",
  OWNER: "Owner",
  INSTALLER: "Installer",
};

export const USER_OPTIONS = {
  USERS: "Users",
  ORGANISATION: "Organisations",
  VPP_REGISTRATIONS: "VppRegistrations",
};

export const USER_OPTIONS_TABS = [
  { label: USER_OPTIONS.USERS, value: USER_OPTIONS.USERS, accessKey: "users" },
  {
    label: USER_OPTIONS.ORGANISATION,
    value: USER_OPTIONS.ORGANISATION,
    restricts: [USER_TYPE.OWNER],
    accessKey: "organisations",
  },
  {
    label: "VPP User Registrations",
    value: USER_OPTIONS.VPP_REGISTRATIONS,
    // Only relevant to Owner users; restricted away from Fleet/Installer.
    restricts: [USER_TYPE.FLEET, USER_TYPE.INSTALLER],
    // Reuses the "users" access grant that already gates the Owner Users page.
    // Swap for a dedicated "vpp_registrations" key once the backend menu exposes it.
    accessKey: "users",
  },
];
